/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CompanyInputs */

const en_company = /** @type {(inputs: CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const de_company = /** @type {(inputs: CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company = /** @type {((inputs?: CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company(inputs)
	return en_company(inputs)
});